export const aboutSectionHeader1 = "Dala Rörservice";
export const aboutSectionText1 =
  "Anlita oss när du behöver rörmokare som du kan lita på! Vi utför arbeten i alla storlekar. Vid behov av större entreprenader, kontakta oss på Dala Rörentreprenad!";
